import Icon from '../components/Icon.vue'

Icon.register({
  italic: {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M204.8 416H170.9L233 96H273.7A16-16 0 0 1 289.4 83.1L295.7 51.1C297.6 41.2 290 32 280 32H120.2A16-16 0 0 1 104.5 44.9L98.3 76.9C96.4 86.8 103.9 96 114 96H147.8L85.7 416H46.3A16-16 0 0 1 30.6 428.9L24.3 460.9C22.4 470.8 30 480 40 480H198.5A16-16 0 0 1 214.2 467.1L220.5 435.1C222.4 425.2 214.8 416 204.8 416z'
      }
    ]
  }
})
